export class AnalyticsService {
    constructor() {
    }

    static callPosthog(name, ...args) {
        if (!window.posthog) {
            return;
        }

        return posthog[name](...args);
    }

    static setPersonProperties(...args) {
        AnalyticsService.callPosthog('setPersonProperties', ...args);
    }

    static capture(...args) {
        AnalyticsService.callPosthog('capture', ...args);
    }

    static onFeatureFlags(...args) {
        AnalyticsService.callPosthog('onFeatureFlags', ...args);
    }

    static getFeatureFlag(...args) {
        return AnalyticsService.callPosthog('getFeatureFlag', ...args);
    }

    static overrideFeatureFlags(...args) {
        if (!window.posthog) {
            return;
        }

        const featureFlags = posthog.featureFlags;

        if (!featureFlags) {
            return;
        }

        featureFlags.override(...args);
    }

    static sendEvent(event, data = {}) {
        const lmsUserData = costorage.get('h_lmsUser');
        let parsedLmsUserData;

        if (lmsUserData) {
            parsedLmsUserData = JSON.parse(lmsUserData);
        }

        if (parsedLmsUserData && parsedLmsUserData['_id']) {
            Object.assign(data, { lms_id: parsedLmsUserData['_id'] });
        }

        AnalyticsService.capture(event, data);
        dataLayer.push({
            event: event,
            ...data
        });
    }
}